import { EGDSSpacing } from '@egds/react-core/spacing';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { SponsoredPropertiesCarousel, useSponsoredPropertiesContext } from '@shared-ui/retail-lodging-sponsored-properties-carousel';
import { adaptSearchCriteria } from 'src/common/stores/adapters/bex-api/common/search-criteria-adapter';
import { getShoppingContextInput } from 'src/common/stores/adapters';
import { PropertySort } from 'stores/models/search-criteria-model';
import { usePlatformContext } from 'src/common/stores/contexts/platformContext';
import { useSearchCriteriaContext } from 'src/common/stores/contexts';
import CarouselContext from 'src/common/stores/contexts/carousel-context-provider';
import PropertyRecsVariantWrapper from '../similar-hotels/property-recs-variant-wrapper';
export const PropertyTopCarouselWrapper = inject('currentHotel', 'multiItem')(observer(props => {
  var _a, _b, _c, _d, _e, _f;
  const context = usePlatformContext();
  const searchCriteria = useSearchCriteriaContext();
  const multiItemContext = (_a = props.multiItem) === null || _a === void 0 ? void 0 : _a.multiItemContext;
  const shoppingContext = getShoppingContextInput(multiItemContext);
  const propertySearchCriteriaNonAds = adaptSearchCriteria(context, searchCriteria);
  const propertySearchCriteriaAds = adaptSearchCriteria(context, searchCriteria);
  propertySearchCriteriaAds.primary.destination.pinnedPropertyId = `${(_c = (_b = props.currentHotel) === null || _b === void 0 ? void 0 : _b.hotelId) !== null && _c !== void 0 ? _c : ''}`;
  propertySearchCriteriaAds.primary.destination.excludedPropertyIds = [`${(_e = (_d = props.currentHotel) === null || _d === void 0 ? void 0 : _d.hotelId) !== null && _e !== void 0 ? _e : ''}`];
  const {
    addTopCarouselName
  } = React.useContext(CarouselContext);
  const {
    isProperties
  } = useSponsoredPropertiesContext();
  React.useEffect(() => {
    if (isProperties) {
      addTopCarouselName('travel-ads');
    }
  }, [isProperties]);
  const canShowSponsoredCarousel = searchCriteria.sort === PropertySort.RECOMMENDED;
  return React.createElement(React.Fragment, null, canShowSponsoredCarousel && React.createElement("div", {
    "data-stid": "sponsored-properties-carousel"
  }, React.createElement(SponsoredPropertiesCarousel, {
    inputs: {
      criteria: propertySearchCriteriaAds,
      shoppingContext: shoppingContext
    },
    skipSsr: true
  })), !isProperties && React.createElement(EGDSSpacing, {
    margin: {
      small: {
        inline: 'three'
      }
    }
  }, React.createElement("div", null, React.createElement(PropertyRecsVariantWrapper, {
    propertyId: String((_f = props.currentHotel) === null || _f === void 0 ? void 0 : _f.hotelId),
    propertySearchCriteriaInput: propertySearchCriteriaNonAds,
    shoppingContext: shoppingContext
  }))));
}));